import { ViewModelBase } from './view-model-base';

export class ListViewModel<T> extends ViewModelBase {
  declare public values: T[];
}
